import type { Profile } from 'models';
import { useState } from 'react';
import { Button, PencilLineIcon, Space } from 'ui';
import { EditProfileModal } from '../../../../components/edit-profile-modal';
import { MemberNavigationButtons } from '../member-navigation-buttons';

type P = {
  viewer: Profile;
};

const ViewerActions = ({ viewer }: P) => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  return (
    <>
      <Space block orientation="vertical" size="small">
        <Button
          block
          icon={<PencilLineIcon />}
          onClick={() => {
            setIsEditModalOpen(true);
          }}
          size="large"
          type="primary"
        >
          Edit profile
        </Button>
        <MemberNavigationButtons memberId={viewer.id} nodeUserId={viewer.nodeId} />
      </Space>
      <EditProfileModal
        isOpened={isEditModalOpen}
        onClose={() => {
          setIsEditModalOpen(false);
        }}
        viewer={viewer}
      />
    </>
  );
};

export default ViewerActions;
